// removed by extract-text-webpack-plugin
module.exports = {"header":"header__header__sBbZe","headerOpt":"header__headerOpt__yvOIn","logo":"header__logo__1BkL2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.css
// module id = 170
// module chunks = 0